import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  CardBody,
  Center,
  Image,
  Stack,
  Divider,
  CardFooter,
  ButtonGroup,
  Button,
  Flex,
  Text,
  Heading,
  VStack,
  Code,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  SimpleGrid,
  Grid,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { Footer } from "../../containers/Footer";
import { getBrandCampaigns } from "../../actions/campaigns";
import CampaignCard from "../../components/campaignCard";
import { validateUserAuth } from "../../helpers"

function Campaigns() {
  const navigate = useNavigate();
  const [userBrand, setUserBrand] = useState("");
  const [brandCampaigns, setBrandCampaigns] = useState([]);
  const [fetchingCampaigns, setFetchingCampaigns] = useState(false);

  const [noCampaigns, setNoCampaigns] = useState(false);
  const lightGray = useColorModeValue("gray.100", "gray.900");

  useEffect(() => {
    setFetchingCampaigns(true);

    const userInfo = validateUserAuth()
    const brand = userInfo.organization;
    if (!brand) {
      navigate("/home");
    }
    setUserBrand(brand);

    getBrandCampaigns(brand).then((campaigns) => {
      if (campaigns.length) {
        setNoCampaigns(true);
      }
      setBrandCampaigns(campaigns);
      setFetchingCampaigns(false);
    });
  }, []);

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      color="blackAlpha.700"
      pb="75px"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <Card
              maxWidth="1200px"
              align
              mx="5"
              mt="10"
              mb="5"
              p="3"
              bg={useColorModeValue("gray.100", "gray.900")}
            >
              <Box mx="25" align="left" px="15">
                <Text fontSize="xl" as="b" mb="2">
                  Welcome to Hubit, the place where you can upload content for
                  your content marketing campaign! Test ahead of, during or
                  after the release of your content.
                </Text>
                <Text fontSize="xl" align="left" mt="6">
                  Upload your images and allow your audiences to select. (6
                  sections with up to 5 slots for content in the form of A/B
                  testing.)
                </Text>

                {((!fetchingCampaigns && !brandCampaigns.length) ||
                  noCampaigns) && (
                  <Box mt="50px" mb="5" width="100%">
                    <Link to="/brandCampaigns/create">
                      <Button colorScheme="green">Create a Campaign</Button>
                    </Link>
                  </Box>
                )}
              </Box>
            </Card>

            {!fetchingCampaigns && brandCampaigns.length !== 0 && (
              <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
                <Flex m="2">
                  <Box width="100%">
                    <Heading fontSize="2xl">Your Campaigns</Heading>
                  </Box>
                  <Box>
                    <Link to="/brandCampaigns/create">
                      <Button colorScheme="green">Create New Campaign</Button>
                    </Link>
                  </Box>
                </Flex>
                <SimpleGrid columns={[2, null, 3]}>
                  {brandCampaigns.map((campaign, idx) => {
                    return <CampaignCard owner={true} campaign={campaign} />;
                  })}
                </SimpleGrid>
              </Card>
            )}
          </VStack>
        </Center>
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default Campaigns;
